import { useApiBase } from "api/base";
import { useCallback } from "react";
import { VariaveisAmbiente } from "ambiente";

export function usePostMerchantAuth() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postMerchantAuth = useCallback(
        (merchantToken: string, merchantCredential: string) => {
            return invocarApi({
                url: `v2/merchant/auth`,
                method: "POST",
                headers: {
                    "Authorization": `${merchantToken}`,
                    "merchantCredential": merchantCredential
                },
                enviarTokenUsuario: false,
                baseURL: `${VariaveisAmbiente.paymentSafraApi}/`,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        postMerchantAuth,
    };
}